<dl class="row" *ngIf="talep">
  <dt class="col-5">Talep No:</dt>
  <dd class="col-7 text-blue clickable" *ngIf="isAuthenticated" (click)="talepGit()">{{talep.talepNo}}</dd>
  <dd class="col-7 text-blue" *ngIf="!isAuthenticated">{{talep.talepNo}}</dd>
  <dt class="col-5">Talep Türü:</dt>
  <dd class="col-7">{{talep.talepTur?.isim}}</dd>
  <dt class="col-5">Ürün Grubu:</dt>
  <dd class="col-7">{{talep.urunGrup?.isim}}</dd>
  <dt class="col-5">Talep Oluşturan:</dt>
  <dd class="col-7">{{talep.kullanici?.adSoyad}}</dd>
  <dt class="col-5">Teslim Yeri</dt>
  <dd class="col-7">{{teslimYeri}}</dd>
  <dt class="col-5" *ngIf="siparis">Sipariş Tarihi</dt>
  <dd class="col-7" *ngIf="siparis">{{siparis?.olusturmaTarihiText}}</dd>
  <dt class="col-5" *ngIf="siparis">Teslim Tarihi</dt>
  <dd class="col-7" *ngIf="siparis">{{teslimSuresi | date:'dd.MM.yyyy'}}</dd>
  <dt class="col-5" *ngIf="siparis">Firma</dt>
  <dd class="col-7" *ngIf="siparis">{{siparis.cari?.firmaUnvani}}</dd>
</dl>

<dl class="row" *ngIf="talep.talepAciklamalar">
  <dt class="col-5">
    <textarea class="form-control" name="example-textarea-input" rows="3" placeholder="Açıklama.."
      [(ngModel)]="aciklama" (change)="setAciklama()"></textarea>
  </dt>
  <dd class="col-7">
    <app-aciklama-gecmisi [source]="talep.talepAciklamalar"></app-aciklama-gecmisi>
  </dd>
</dl>

<div class="row">
  <div class="col-md-12 col-lg-12">
    <div class="mb-3">
      <div class="row row-sm">
        <div class="col-6 col-sm-3 attachment" *ngFor="let g of talep.talepGorseller;let index = i">
          <div class="container">
            <img [src]="g.getUri()" alt="" class="image" style="width:100%">
            <div class="middle">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="ml-auto">
                    <a class="text clickable" (click)="downloadFile(g.dosya)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                      stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                      <polyline points="7 11 12 16 17 11"></polyline>
                      <line x1="12" y1="4" x2="12" y2="16"></line>
                    </svg>
                    Görüntüle
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>